/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import { getLocalValue } from "../../utils/auth";
import styles from "./index.module.scss";

export function Metric({
  isCampaign,
  userId,
  customParams,
  filterParams,
  data,
  info,
  ...props
}) {
  const urlParams = props.params ? props.params : "uid";
  const coach_id = userId ? userId : getLocalValue("uid");
  const campaignKey = isCampaign ? `&campaign_id=${isCampaign}` : "";
  const numberFormat = new Intl.NumberFormat();
  let url = `/api/${props.api}?${urlParams}=${coach_id}${campaignKey}${filterParams ? filterParams : ""
    }`;

  if (customParams) {
    url = `/api/${props.api}?${customParams}`;
  }
  const { addNotification } = useNotification();
  const [responseData, setResponseData] = useState(null);
  const [count, setCount] = useState(data ? data : null);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (props.api) {
      fetchData();
    }
  }, [isCampaign, customParams, props.api, filterParams]);

  useEffect(() => {
    setCount(data);
  }, [data]);

  // fetch from getSessionDetails api
  async function fetchData() {
    setIsLoading(true);

    // const apiAttr = getAttr(props.api )
    const response = await apiRequest.get(url);

    if (response.status === 200) {
      setResponseData(response.data);
      setIsLoading(false);
      if (response.data.msg) {
        setCount(0);
      } else {
        if (eval(props.responseKey)) {
          const data =
            eval(props.responseKey).length === 0
              ? 0
              : parseFloat(eval(props.responseKey)).toFixed(0);
          setCount(numberFormat.format(data));
        } else {
          setCount(0);
        }
      }
    } else {
      setIsLoading(false);
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
  }

  return (
    <Fragment>
      <div
        className={styles.metric}
        style={{ width: `${props.fullWidth ? "33%" : "auto"}` }}
      >
        {info && <span className={styles.info}> {info} </span>}
        <span
          className={styles.count}
          style={{
            color: `${props.color && props.color}`,
            fontSize: `${props.fontSize && props.fontSize}`,
          }}
        >
          {count ? count : 0}{" "}
        </span>
        {/* {isLoading && <Loader />} */}
        <span className={styles.label}>{props.label}</span>
      </div>
    </Fragment>
  );
}

export function MetricsWrapper({ ...props }) {
  return (
    <div
      className={`${props.dashboard ? styles.dashboardMetricsWrapper : styles.metricsWrapper
        }`}
    >
      {props.children}
    </div>
  );
}